import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var handle_default = /* @__PURE__ */ jsx(SVG, { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(Path, { d: "M7 16.5h10V15H7v1.5zm0-9V9h10V7.5H7z" }) });
export {
  handle_default as default
};
//# sourceMappingURL=handle.js.map
